export default __webpack_public_path__ + "static/media/levels.74aca444.svg";